var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq__next-page"},[_c('router-link',{staticClass:"faq__next-page--title",attrs:{"to":"/contact","tag":"h2"}},[_vm._v(_vm._s(_vm.$t("faqTranslate.faqNextPageLinkToNextPage")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }